module.exports = __webpack_public_path__ + "static/media/add.72d71e70.svg";